import { type FC } from 'react';
import { useBoostFirebaseEvents } from '@common/hooks/boost-firebase-events';
import { QuarryActiveBoostItem } from '@components/ActiveBoostItem/QuarryActiveBoostItem/QuarryActiveBoostItem';
import { BoostCard } from '@components/BoostCard/BoostCard';
import { BoostFirebaseEventsContext } from '@context/BoostFirebaseEventContext';
import { useModal } from '@context/ModalContext';
import {
  selectActiveBoostForQuarry,
  selectActiveQuarriesBoosts,
  selectFreeBoostForQuarry,
  selectQuarriesList,
  selectVipBoostForQuarry,
} from '@redux/selectors/quarrySelectors';
import { useAppSelector } from '@redux/store';

import PlantBoostModal from '../PlantBoostModal';

const QuarriesBoostModal: FC = () => {
  const activeBoosts = useAppSelector(selectActiveQuarriesBoosts);
  const { isQuarryBoostModalOpen, setIsQuarryBoostModalOpen } = useModal();
  const freeBoost = useAppSelector((state) => selectFreeBoostForQuarry(state));
  const vipBoost = useAppSelector((state) => selectVipBoostForQuarry(state));
  const quarriesList = useAppSelector(selectQuarriesList);
  const activeBoost = useAppSelector(selectActiveBoostForQuarry);
  const events = useBoostFirebaseEvents({}, activeBoost, quarriesList);

  return (
    <BoostFirebaseEventsContext.Provider value={events}>
      <PlantBoostModal
        plantType="Quarry"
        activeBoostList={activeBoosts}
        activeBoostItem={(props) => (
          <QuarryActiveBoostItem key={props.id} {...props} />
        )}
        boostCardList={[freeBoost, vipBoost].map((boost) => ({
          ...boost,
          variant: 'big',
          plantType: 'Quarry',
        }))}
        boostCardItem={(props) => (
          <BoostCard key={props.boostType} {...props} />
        )}
        isPlantBoostOpen={isQuarryBoostModalOpen}
        setOpenPlantBoostModal={setIsQuarryBoostModalOpen}
      />
    </BoostFirebaseEventsContext.Provider>
  );
};

export { QuarriesBoostModal };
